var angular = require('angular');
var _module = require('../../module');
var _ = require('lodash');

require('angular-simple-logger');
require('../../third-party/angular-google-maps');
require('../../../services/analytics');
require('../../../services/error-modal');
require('../../listing-card');

_module.component('mapResults', {
    bindings: {
        isMobile: '<',
        map: '=mapConfig',
        results: '=mapData',
        ui: '=uiFeedback',
        keyword: '<',
        searchSubmit: '&',
        updateUserCurrentState: '&'
    },
    controllerAs: 'mapResults',
    controller: [
        '$scope',
        '$log',
        '$filter',
        '$compile',
        '$timeout',
        '$state',
        '$window',
        'uiGmapGoogleMapApi',
        'uiGmapIsReady',
        'srUtils',
        '$analytics',
        '$user',
        '$errorModal',

        function mapResultsCtrl($scope, $log, $filter, $compile, $timeout, $state, $window, uiGmapGoogleMapApi, uiGmapIsReady, srUtils, $analytics, $user, $errorModal) {
            var _this = this;

            var getInfoWindowContent = function (data) {
                return {
                    id: data.id,
                    heroImage: data.heroImage,
                    heroImageFallback: data.heroImageFallback,
                    address: data.address,
                    price: data.price,
                    matchScore: data.match_score || null,
                    homeSpecs: srUtils.getHomeSpecs(data),
                    detailViewUrl: srUtils.getDetailViewUrl(data.detailViewParams)
                };
            };

            var onMarkerMouseOver = function (data) {
                _this.map.selectedMarker = data;
                _this.map.selectedResult = _.find(_this.results, {'id': data.id});
                if(_this.map.selectedResult){
                    _this.iwContent = getInfoWindowContent(_this.map.selectedResult);
                    _this.map.showWindow = true;
                }
            };

            var onMarkerMouseOut = function (data) {
                _this.map.showWindow = false;
            };

            var onMarkerClicked = function (data) {
                _this.map.selectedMarker = data;
                _this.map.selectedResult = _.find(_this.results, {'id': data.id});

                var trackingObj = {
                    'Source': 'Map View',
                    'Filter ID': (_this.ui.resultSource == 'filter' && $user.currentFilter) ? $user.currentFilter.id : null
                };

                if(_this.map.selectedResult){
                    var secondClick = (_this.iwContent && _this.iwContent.id === data.id);
                    _this.iwContent = getInfoWindowContent(_this.map.selectedResult);

                    if(_this.iwContent && _this.iwContent.detailViewUrl && !_this.isMobile) {
                        srUtils.openDetailView(_this.map.selectedResult.detailViewParams);
                    }else if(_this.isMobile){
                        _this.showInfoWindow = (secondClick)
                                                ? !_this.showInfoWindow
                                                : true;
                    }

                    trackingObj = _.extend({}, trackingObj, {
                        'Match Score': _this.map.selectedResult.match_score,
                        'Address': _this.map.selectedResult.address,
                        'Sq Ft': _this.map.selectedResult.livingArea,
                        'Bed': _this.map.selectedResult.beds,
                        'Bath': _this.map.selectedResult.baths,
                        'Price': _this.map.selectedResult.price
                    });
                }

                $analytics.eventTrack('Listing Detail View Click', trackingObj);
            };

            var markerInteractionHandler = function (marker, eventName, args) {
                if(eventName == 'mouseover' && !_this.isMobile) {
                    $scope.$apply(onMarkerMouseOver(args));
                }else if (eventName == 'mouseout' && !_this.isMobile) {
                    $scope.$apply(onMarkerMouseOut(args));
                }else if (eventName == 'click') {
                    $scope.$apply(onMarkerClicked(args));
                }
            };

            var initMatchScoresVisible = function () {
                _this.matchScoresVisible = {
                    high: true,
                    med: true,
                    low: false
                };
            };

            var initMapMarkers = function () {
                var labelClass = 'map-marker-label';
                var labelAnchor = '18 39';
                var correctionMultiplier = 2; // threshold multiplier for filtering out pins that deviate a lot from the cluster

                var markers = [];
                $log.debug('Original Length', _this.results.length);
                var filteredResults = $filter('removeNonGeocoded')(_this.results);
                filteredResults = srUtils.filterOutsideStandardDeviation(filteredResults, correctionMultiplier);
                $log.debug('Filtered Length', filteredResults.length);
                if(filteredResults && angular.isArray(filteredResults) && filteredResults.length > 0) {
                    filteredResults.forEach(function (listing, i) {
                        var rankClass;
                        if(!!listing && listing.hasOwnProperty('match_score')){
                            rankClass = (listing.match_score >= 75)
                                            ? 'high'
                                            : (listing.match_score >= 50)
                                                ? 'med'
                                                : 'low';
                        }else{
                            rankClass = 'high';
                        }

                        markers.push({
                            id: listing.id,
                            latitude: listing.lat,
                            longitude: listing.lon,
                            icon: '/images/search-results/marker-transparent.png',
                            options: {
                                labelContent: '$' + $filter('numberAbbreviate')(listing.price, 1),
                                labelClass: labelClass + ' ' + rankClass,
                                labelAnchor: labelAnchor,
                                visible: !!_this.matchScoresVisible[rankClass],
                                zIndex: listing.match_score
                            }
                        });
                    });
                }

                if(markers && angular.isArray(markers) && markers.length > 0) {
                    _this.markers = markers;
                }
            };

            var setMapCenterToKeywordLatLng = function setMapCenterToKeywordLatLng(gmaps) {
                if(gmaps) {
                    srUtils.geocodeKeyword(_this.keyword)
                        .then(function (gmapsLatLng) {
                            if(gmapsLatLng){
                                $log.debug('setMapCenterToKeywordLatLng ->', gmapsLatLng);
                                google.maps.event.trigger(gmaps[0].map, 'resize');
                                gmaps[0].map.setCenter(gmapsLatLng);
                            }
                        });
                }
            };

            var updateUserCurrentState = function (key, val) {
                $timeout(function () {
                    _this.updateUserCurrentState({$key: key, $val: val});
                }, 10);
            };

            var saveUserCurrentMapConfig = function (gmaps) {
                if(gmaps && gmaps[0] && gmaps[0].map) {
                    var mapCenterLatLng = gmaps[0].map.getCenter();
                    var mapCenter = {
                        latitude: mapCenterLatLng.lat(),
                        longitude: mapCenterLatLng.lng()
                    };
                    var mapZoom = gmaps[0].map.getZoom();
                    updateUserCurrentState('mapCenter', mapCenter);
                    updateUserCurrentState('mapZoom', mapZoom);
                }
            };

            var triggerMapResize = function (gmaps) {
                if(gmaps && gmaps[0] && gmaps[0].map){
                    var currCenter = gmaps[0].map.getCenter();
                    if(_this.keyword && _this.keyword.length &&
                        !( _this.markers && _this.markers.length) ) {

                        // Try to update map center for the case
                        // where there are valid results
                        // for a keyword, but no map markers,
                        // since all results got filtered out due to
                        // invalid lat/lng or failed the std deviation check

                        setMapCenterToKeywordLatLng(gmaps);
                    } else {
                        google.maps.event.trigger(gmaps[0].map, 'resize');
                        gmaps[0].map.setCenter(currCenter);
                    }

                    $log.debug('Triggered Map Resize', gmaps[0].map);
                }
            };

            var stripCountry = function (str) {
                return (str || '').replace(/,?\s*USA$/ig, '');
            };

            var hideMapSearchOverlay = function () {
                if(_this.ui) {
                    _this.ui.showMapSearchOverlay = false;
                }
            };

            var showMapSearchOverlay = function () {
                var newKeyword = _this.mapSearch.keyword;
                var source = _this.mapSearch.source;

                if(newKeyword && source &&
                    stripCountry(_this.keyword) !== stripCountry(newKeyword)) {
                    $log.debug('Current Keyword: ', _this.keyword);
                    _this.ui.showMapSearchOverlay = true;
                    _this.mapSearch.keyword = stripCountry(newKeyword);
                    _this.mapSearch.source = source;
                } else {
                    hideMapSearchOverlay();
                }
            };

            var reverseGeocodeLatLon = function (newLat, newLon, source) {
                srUtils.reverseGeocodeLatLon(newLat, newLon)
                    .then(function (res) {
                        if(res && res.formatted_address) {
                            updateMapSearchMetadata(res.formatted_address, source);
                            showMapSearchOverlay();
                        } else {
                            hideMapSearchOverlay();
                        }
                    })
                    .catch(function (err) {
                        hideMapSearchOverlay();
                        $log.error(err);
                    });
            };

            var initMapEventHandlers = function () {
                var eventHandlersObj = {
                    dragend: function dragEndHandler(map, eventName) {
                        if(map && map.getCenter){
                            var newCenter = map.getCenter();
                            var newLat = newCenter.lat();
                            var newLon = newCenter.lng();
                            reverseGeocodeLatLon(newLat, newLon, 'map_search');
                        }else {
                            hideMapSearchOverlay();
                            $log.debug('Couldn\'t get map or map center after drag: ', map);
                        }
                    }
                };

                _this.mapEventHandlers = eventHandlersObj;
            };

            var initMapPresets = function () {
                var fitFlag = (!_this.ui || (_this.ui && _this.ui.resultSource !== 'map_search'));
                try{
                    var mapPresets = {
                        options: {
                            scrollwheel: true,
                            fit: !!fitFlag,
                            minZoom: 9,
                            mapTypeControlOptions: {
                                position: google.maps.ControlPosition.LEFT_BOTTOM
                            },
                            fullscreenControl: false
                        },
                        markerControl: {},
                        markerEvents: {
                            mouseover: markerInteractionHandler,
                            mouseout: markerInteractionHandler,
                            click: markerInteractionHandler
                        },
                        showWindow: false,
                        selectedResult: null
                    };

                    _this.map = _.extend(_this.map, mapPresets);

                }catch (e) {
                    $log.error("Couldn't set map presets! ", e);
                }
            };


            var updateMapSearchMetadata = function (keyword, source) {
                var updateObj = {
                    keyword: keyword,
                    source: source
                };

                _this.mapSearch = _.extend(_this.mapSearch, updateObj);
            };

            var initMapSearchMetadata = function () {
                _this.mapSearch = {
                    keyword: null,
                    source: null
                };
            };

            var trackSearchSubmitted = function () {
                var trackingSourceMap = {
                    'map_search': 'Map Refocus',
                    'user_location': 'Show My Location'
                };

                var trackingSource = (trackingSourceMap.hasOwnProperty(_this.mapSearch.source))
                    ? trackingSourceMap[_this.mapSearch.source]
                    : 'Map Refocus';

                $analytics.eventTrack('Listing Search Submit', {
                    Source: trackingSource,
                    'Search Term': _this.mapSearch.keyword
                });
            };

            var init = function () {
                initMatchScoresVisible();
                initMapPresets();
                initMapEventHandlers();
                initMapSearchMetadata();
                hideMapSearchOverlay();

                if(!!_this.results){
                    uiGmapGoogleMapApi
                        .then(function (gmaps) {
                            initMapMarkers();
                        })
                        .catch(function (err) {
                            $log.error('Failed to load Google Maps API: ', err);
                        });

                    uiGmapIsReady
                        .promise(1)
                        .then(function (gmaps) {
                            $log.debug('Map Ready! ', gmaps);
                            $log.debug('Markers Ready! ', _this.map.markerControl);
                            triggerMapResize(gmaps);
                            saveUserCurrentMapConfig(gmaps);
                            //initMapPresets();
                        })
                        .catch(function (err) {
                            $log.error('Failed to load Map: ', err);
                        });
                }
            };

            init();

            /////////////////////////
            //      PUBLIC FNs     //
            /////////////////////////

            this.openDetailView = function (params) {
                srUtils.openDetailView(params);
            };

            this.toggleMatchScoreVisible = function (rankClass) {
                if(rankClass && _this.matchScoresVisible && _this.matchScoresVisible.hasOwnProperty(rankClass)) {
                    _this.matchScoresVisible[rankClass] = !!!_this.matchScoresVisible[rankClass];
                    _this.refreshMarkers();
                }
            };

            this.hideMarkers = function () {
                if(_this.markers){
                    _this.markers.forEach(function (marker, i) {
                        marker.options.visible = false;
                    });
                }
            };

            this.refreshMarkers = function () {
                //hide any open info windows before refreshing markers
                _this.map.showWindow = false;
                initMapMarkers();
            };

            this.getUserLocation = function getUserLocation() {
                var coords = null;
                _this.ui.loadingUserLocation = true;
                srUtils
                    .getUserLocation()
                    .then(function (res) {
                        coords = res;
                        return uiGmapIsReady.promise(1);
                    })
                    .catch(function (err) {
                        $errorModal(err);
                    })
                    .then(function (gmaps) {
                        if(gmaps && angular.isArray(gmaps) && gmaps[0] && gmaps[0].map &&
                            coords && coords.latitude && coords.longitude) {
                            reverseGeocodeLatLon(coords.latitude, coords.longitude, 'user_location');
                            _this.userLocationMarker = {
                                id: 'user_location_marker',
                                coords: {latitude: coords.latitude, longitude: coords.longitude},
                                options: {
                                    icon: '/images/search-results/user-location-marker.png'
                                }
                            };
                            gmaps[0].map.panTo(
                                new google.maps.LatLng(coords.latitude, coords.longitude)
                            );
                        }
                    })
                    .catch(function (err) {
                        $log.error('Could not find google maps instance.', err);
                    })
                    .finally(function () {
                        _this.ui.loadingUserLocation = false;
                    });
            };


            this.onSubmit = function onFormSubmit() {
                if(_this.mapSearch && _this.mapSearch.keyword) {
                    $timeout(function onFormSubmitTO() {
                        _this.searchSubmit({ $keyword: _this.mapSearch.keyword, $latLng: undefined, $noPageReset: false, $source: _this.mapSearch.source });
                    }, 200);

                    trackSearchSubmitted();
                }
            };

            this.getCurrentFilterId = function getCurrentFilterId() {
                $log.debug('getCurrentFilterId', _this.ui, _this.ui.resultSource === 'filter', $user.currentFilter.id);

                if(!(_this.ui.resultSource === 'filter' && $user.currentFilter && $user.currentFilter.id)) return undefined;

                return $user.currentFilter.id;
            };

            ///////////////////////
            //      WATCHERS     //
            ///////////////////////

            $scope.$watch(
                function watchResults( scope ) {
                    return _this.results;
                },
                function handleResultsChange( newValue, oldValue ) {
                    if(
                        newValue !== oldValue &&
                        angular.isArray(newValue) &&
                        newValue.length > 0
                    ) {

                        initMapPresets();
                        hideMapSearchOverlay();

                        uiGmapGoogleMapApi
                        .then(function (gmaps) {
                            $log.debug('Refreshing markers in watcher');
                            _this.refreshMarkers();
                        })
                        .catch(function (err) {
                            $log.error('Failed to load Google Maps API: ', err);
                        });

                        uiGmapIsReady
                        .promise(1)
                        .then(function (gmaps) {
                            $log.debug('Map Ready! ', gmaps);
                            $log.debug('Markers Ready! ', _this.map.markerControl);
                            triggerMapResize(gmaps);
                            saveUserCurrentMapConfig(gmaps);
                            //initMapPresets();
                        })
                        .catch(function (err) {
                            $log.error('Failed to load Map: ', err);
                        });
                    } else {
                        initMapPresets();
                        hideMapSearchOverlay();
                        _this.hideMarkers();

                        // since no results are found, we try to
                        // center the map to the new keyword's lat/lng
                        if(angular.isArray(newValue)) {
                            // ensures this does not run if newValue is not defined;
                            // to avoid multiple invocations of the watcher
                            uiGmapIsReady
                            .promise(1)
                            .then(function (gmaps) {
                                setMapCenterToKeywordLatLng(gmaps);
                            })
                            .catch(function (err) {
                                $log.error('Failed to center map with no markers: ', err);
                            });
                        }
                    }
                }
            );

            $scope.$watch(
                function watchResults( scope ) {
                    return _this.ui.exceptions.noResults;
                },
                function handleResultsChange( newValue, oldValue ) {
                    if( newValue !== oldValue && String(newValue) === 'true'){
                        _this.hideMarkers();
                    }
                }
            );
        }
    ],
    template: require('./index.html')
});
